import { TranslateUnauthenticatedPipe } from '../../../filters/translate-unauthenticated.pipe';
import { ItemErrorComponent } from '../../../components/item-form-error/item-form-error.component';
import { ItemFormErrorWithTranslatorComponent } from '../../../components/item-form-error-with-translator/item-form-error-with-translator.component';
import { AfterViewInit, Component, OnDestroy, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { LoaderOverlayComponent } from '../../../components/loader-overlay/loader-overlay.component';
import Config from '../../../utils/config.service';
import Session from '../../../utils/session.service';
import AngularFilterHelperService from '../../../services/angular-filter-helper.service';
import AngularRoutingHelperService from '../../../services/angular-routing-helper.service';
import AppLanguageService from '../../../services/app-language.service';
import { Subscription } from 'rxjs';

@Component({
	standalone: true,
	selector: 'sk-auth',
	templateUrl: './sk-auth.component.html',
	imports: [
		CommonModule, TranslateUnauthenticatedPipe, ItemErrorComponent, RouterLink,
		ItemFormErrorWithTranslatorComponent, FormsModule, LoaderOverlayComponent
	]
})
export default class SkAuthComponent implements OnInit, AfterViewInit, OnDestroy {
	private config: Config = inject(Config);
	private session: Session = inject(Session);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	private appLanguageService: AppLanguageService = inject(AppLanguageService);
	
	vm: any = undefined;
	private titleSubscription: Subscription = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngAfterViewInit(): void {
		const script = document.createElement('script');
		script.src = 'https://s3-eu-west-1.amazonaws.com/sk-auth/sk-auth-1.6.2.min.js';
		script.async = true;

		document.getElementById('skAuthScript')?.appendChild(script);
		script.onload = () => {
			var successPath = this.vm.targetUrl ? this.vm.targetUrl : '/';
			var forceUsePathOnly = true;
			if (this.vm.isPrevisit) {
				successPath = window.location.origin + "/rest/previsit/redirect/filter?route=" + successPath;
				forceUsePathOnly = false;
			}
			window['skAuthModule'].setOptions(this.vm.locale.split('_')[0], successPath, forceUsePathOnly);
			window['skAuthModule'].initSkAuth();
		};
	}
	
	ngOnInit() {
		var currentSession = this.session.getSession();
		var origin: any = (currentSession && currentSession.user && currentSession.user.origin)
			? currentSession.user.origin
			: 'minudoc.ee';
		this.vm.origin = origin;

		var location: any = window.location.href;
		if (location.includes('eelvisiit')) {
			this.vm.isPrevisit = true;
		}
		var queryParams: any = this.angularRoutingHelperService.getQueryParams();
		
		this.vm.targetUrl = queryParams['targetUrl'];
		
		this.vm.isLanguageMenuOpen = false;
		this.vm.locale = queryParams['locale'] || 'en_GB';
		this.vm.localeParams = this.vm.locale ? { locale: this.vm.locale } : undefined;
		window.sessionStorage.setItem("locale", this.vm.locale);
		this.vm.locales = this.appLanguageService.getLanguagesByOrigin(origin);
		var currentSession = this.session.getSession();
		this.vm.isAuthenticated = !!currentSession;
		if (this.vm.isAuthenticated) {
			if (this.vm.targetUrl) {
				this.angularRoutingHelperService.setPath(this.vm.targetUrl);
			} else {
				this.angularRoutingHelperService.home(currentSession.user);
			}
			return;
		}
		
		this.vm.language = window.navigator.language;
		this.vm.lang = window.sessionStorage.getItem("locale") || 'et_EE' ;
		
		this.vm.setLocale = this.setLocale;
		this.vm.navigateToRoot = this.navigateToRoot;
		this.vm.getLocaleOption = this.getLocaleOption;
		
		this.titleSubscription = this.angularFilterHelperService.watchDocumentTitleUnauthenticated('Login.Login_Title');
	}

	ngOnDestroy() {
		if (this.titleSubscription) {
			this.titleSubscription.unsubscribe();
		}
	}
	
	navigateToRoot($event) {
		$event.preventDefault();
		window.location.href = this.config.getPublicWebHomeUrl(this.vm.origin, this.vm.locale);
	}
	
	setLocale(locale) {
		this.angularRoutingHelperService.setQueryParam('locale', locale);
		setTimeout(() => {
			window.location.reload();
		}, 300);
	}

	getLocaleOption(locale) {
		return this.appLanguageService.getLanguage(locale);
	}
	
}
